<template>
	<div class="message-page">
		<div class="header">
		  <div class="title">全部消息</div>
		</div>
		<div class="main">
			<div class="category-tab-nav">
				<ul>
					<li><a href="javascript:;">全部类型消息</a></li>
					<li><a href="javascript:;">安全消息</a></li>
					<li><a href="javascript:;">安全消息</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    name: 'WholeMessage',
    data(){
      return {
      }
    },
    methods:{
    },
    created(){
    },
  }
</script>

<style>
</style>

<style scoped>
	.message-page>.main{
		margin-top: 24px;
	}
	.category-tab-nav li {
		width: 115px;
		text-align: center;
		float: left;
		position: relative;
		display: block;
	}
	.category-tab-nav li a {
		border-radius: 0px;
		border: 1px solid #D9DEE4;
		background-color: #D9DEE4;
		color: #666;
		line-height: 32px;
		height: 32px;
		margin-left: 2px;
		position: relative;
		display: block;
	}
</style>
